var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.child || "save-button", {
    tag: "component",
    attrs: {
      animating: _vm.saveProductAnimating,
      classes: _vm.classList,
      score: _vm.score
    },
    on: {
      click: function($event) {
        $event.stopPropagation()
        return _vm.saveProduct(_vm.product)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f245e8a", { render: render, staticRenderFns: staticRenderFns })
  }
}